import React from "react"
import PropTypes from "prop-types"
import _ from "lodash"

import ExpandIcon from "@material-ui/icons/AddBoxSharp"
import CollapseIcon from "@material-ui/icons/IndeterminateCheckBoxSharp"

import { IconButton } from "@material-ui/core"
import { inferTextAlignFromFilterType, RIGHT } from "../tableUtil"
import { completeUrlForHrefLink } from "../../../commons/iFrameUtils"

const FLEX_END = "flex-end"
const FLEX_START = "flex-start"

function adaptTextAlignToFlex(textAlign) {
  if (textAlign === RIGHT) {
    return FLEX_END
  }
  return FLEX_START
}

const Cell = ({ data, style, className, level, fold, isFolded }) => {
  const { text, filter } = data

  const pads = []
  _.times(level, (index) =>
    pads.push(<div className="tree-padding" key={index} />)
  )

  const Icon = isFolded ? ExpandIcon : CollapseIcon

  // FIXME SR: this could be memoized at table initialization
  // if its too difficult, because of tree structure
  // make a lazy initialisation when processing tree in depth
  const textAlign = inferTextAlignFromFilterType(filter)
  const justifyContent = adaptTextAlignToFlex(textAlign)
  let textContent
  if (text.match(/<.+>.+<.+>/)) {
    /* necessary because reports can have html embeded */
    /* eslint-disable-next-line react/no-danger */

    const htmlText = completeUrlForHrefLink(text)
    textContent = (
      <div dangerouslySetInnerHTML={{ __html: htmlText }} style={{ flex: 1 }} />
    )
  } else {
    textContent = text
  }
  return (
    <td className={className} style={style}>
      <div style={{ display: "flex", justifyContent, alignItems: "center" }}>
        {pads}
        {fold && (
          <IconButton
            aria-label="delete"
            size="small"
            style={{ padding: 0 }}
            onClick={fold}
          >
            <Icon fontSize="inherit" />
          </IconButton>
        )}
        <span>{textContent}</span>
      </div>
    </td>
  )
}

Cell.propTypes = {
  data: PropTypes.object.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  level: PropTypes.number,
  fold: PropTypes.func,
  isFolded: PropTypes.bool
}

Cell.defaultProps = {
  isFolded: false,
  fold: undefined,
  level: 1,
  style: undefined,
  className: ""
}

export default Cell
